import type { FaireProductEntity } from "../../entity_types/product";

export const p_2x64a2zvr7: FaireProductEntity = {
  token: "p_2x64a2zvr7",
  type: "product",
  name: "Pressure Squishy Toy Butter 12-pc Set | 40BTS414-Pack 12",
  brandToken: "b_9j5az29aau",
  brandName: "JOSSLYN by wall to wall",
  imageUrl:
    "https://cdn.faire.com/fastly/9475bcdfe13eeb1954acbbe22ffefdd3a2f93f0f9c0100f218243a46b3689bf2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0bbe4917692c65c12668129d1354572e9fac392918989539bd32a565da744700.jpeg",
    "https://cdn.faire.com/fastly/573ee9901ca5d9d2a39c1dc74210f7551acb0c1b89dec1151fc91482ef140fa7.jpeg",
  ],
  priceDollars: 3.5,
  description:
    "Butter Sticker Relieve Pressure Squishy Toy.  Provide a satisfying stress relief experience with a playful twist. \n\nMaterial: PU foam\nTexture: Soft, slow-rising\nSize: Approx. 14 × 4 × 4 cm\n\nKey Applications & Benefits\n-Stress & Anxiety Relief: The soft, squeezable texture helps reduce tension.\n-Enhanced Focus & Concentration: Ideal for professionals or students who need a quiet, non-disruptive way to keep their hands busy, which can help sustain attention during long tasks.\n-Portable Fidgeting: Small and lightweight enough to slip into a pocket or bag, making them an easy go-anywhere tool for calming nerves while traveling, commuting, or waiting in line.\n\nWARNING: This product is not a toy. Not intended for children under 14 years of age.\n\nNotice to California Residents:\nDue to Proposition 65 regulations, we are unable to sell or ship this product to customers in California.",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:48.020Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
